const API_BASE = "/api"; // 개발 시는 proxy 사용, 배포 시 nginx가 /api 프록시 처리

export const API_URL = {
    LOGIN: `${API_BASE}/perform_login`,
    LOGOUT: `${API_BASE}/logout`,
    AUTH_STATUS: `${API_BASE}/authStatus`,
    SIGNUP: `${API_BASE}/signup`, // 필요 시 추가
};
